<template lang="pug">
button.btn_back(@click="$router.push(`/${globalVars.langCode}`)")
  <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24"><path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/></svg>
</template>

<script>
export default {
  name: "ButtonBackArrow",
  inject: ["globalVars"],
};
</script>
